import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App.tsx';
import { hydrateDataFromWindow, loadAllData } from './lib/data-loader';
import { installDevConsentGuard } from './lib/safeStorage';
import './index.css';

// 260518-M-03: Dev-mode Warnung bei ungated localStorage.setItem-Aufrufen
// fuer kuenftige Tracking-Integrationen. No-op in Produktiv-Builds.
installDevConsentGuard();

const rootElement = document.getElementById('root')!;

async function main() {
  // CR-01: Vorhandenes pre-rendered Markup bedeutet, dass bereits zur
  // Build-Zeit mit den Strapi-Daten gerendert wurde. In diesem Fall DARF im
  // Browser kein erneuter Fetch passieren — sonst wuerde der data-loader
  // Store neuere Daten enthalten als das HTML, und React hydrateRoot
  // schlaegt mit Hydration-Mismatch-Warnings fehl bzw. wirft Subtrees weg.
  // Per D-01 (04-CONTEXT.md): rein SSG, kein Runtime-Fetching im Browser.
  const hasPreRenderedContent = rootElement.innerHTML.trim().length > 0;

  if (!hasPreRenderedContent) {
    // Nur im Dev-Modus (npm run dev, kein Prerender) Strapi live fetchen,
    // damit die Seite im Browser mit echten Inhalten rendert.
    try {
      await loadAllData();
    } catch (err) {
      console.warn(
        '[main] Strapi data fetch failed in dev mode — using hardcoded fallbacks',
        err
      );
    }
  }

  const app = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );

  if (hasPreRenderedContent) {
    // Plan 09.3-06 (BUGFIX-01): VOR hydrateRoot muessen wir den data-loader
    // Store aus dem inlined `window.__SSG_DATA__` Payload restaurieren, das
    // prerender.tsx in jedes pre-gerenderte HTML emittiert hat. Ohne diesen
    // Aufruf ist der Module-Scope-Store im frisch geladenen Browser-JS leer
    // (EMPTY_DATA) — React re-rendered dann mit leeren Strapi-Daten und
    // stellt Mismatches zum SSG-HTML fest → #418/#422/#425 Errors.
    hydrateDataFromWindow();
    hydrateRoot(rootElement, app);
  } else {
    createRoot(rootElement).render(app);
  }
}

main();
